const liveRoutes = []

/* 登录 */
liveRoutes.push({
  path: '/live',
  name: 'live_index',
  component: () => import(/* webpackChunkName: "live" */ '@/components/live/index.vue')
})

// 单场直播
liveRoutes.push({
  path: '/live/:id',
  name: 'live_show',
  component: () => import(/* webpackChunkName: "live" */ '@/components/live/show.vue')
})

// 系列直播
liveRoutes.push({
  path: '/live/series/:id',
  name: 'series_show',
  component: () => import(/* webpackChunkName: "live" */ '@/components/live/seriesShow.vue')
})
export default liveRoutes



// WEBPACK FOOTER //
// ./src/router/live/index.js